import { RouteConfig } from 'vue-router'

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'shop',
    component: () => import('../views/ShopView.vue'),
  },
  {
    path: '/account/:action?',
    name: 'account',
    component: () => import('../views/Account.vue'),
  },
  {
    path: '/payment',
    name: 'payment',
    component: () => import('../views/Payment.vue'),
  },
  {
    path: '/confirmation',
    name: 'confirmation',
    component: () => import('../views/Confirm.vue'),
  },
  {
    path: '/complete',
    name: 'complete',
    component: () => import('../views/Complete.vue'),
  },
  {
    path: '/free-trial',
    name: 'free-trial',
    component: () => import('../views/FreeTrial.vue'),
  },
  {
    path: '/premium-monthly',
    name: 'premium-monthly',
    component: () => import('../views/PremiumMonthlyPromoView.vue'),
  },
  {
    path: '/eeda-presale',
    name: 'eeda-presale',
    component: () => import('../views/EDAPremiumPreSaleView.vue'),
  },
  {
    path: '/dive',
    name: 'skill-dive',
    component: () => import('../views/SkillDivePreSaleView.vue'),
  },
  // Always leave this route as last one.
  {
    path: '*',
    redirect: '/',
  },
]

export default routes
